import router from '@/router'

const emailsTemplatesModule = {
  state: {
    items: null,
    stripo_default_templates: null,
  },
  mutations: {
    setEmailsTemplatesList (state, emails_templates) {
      state.items = emails_templates
    },
    setEmailTemplate (state, template) {
      state[template.id] = template
    },
    setStripoDefaultTemplates (state, templates) {
      state.stripo_default_templates = templates
    },
  },
  actions: {
    sortTemplates ({ commit, state }, sort) {
      // Создаем копию массива чтобы не мутировать state напрямую
      let items = [...state.items]
      
      let new_sort = items.sort((a, b) => {
        // Определяем поле для сортировки (по умолчанию number)
        const sortField = sort.sort_field || 'number'
        
        if (sortField === 'number') {
          const aNum = a.number ?? Infinity
          const bNum = b.number ?? Infinity
          
          if(sort.sort_direction === 'asc') {
            return aNum - bNum
          } else {
            return bNum - aNum
          }
        } else if (sortField === 'name') {
          if(sort.sort_direction === 'asc') {
            return a.name.localeCompare(b.name)
          } else {
            return b.name.localeCompare(a.name)
          }
        } else if (sortField === 'used_in_autocasts') {
          const aVal = Number(a.used_in_autocasts)
          const bVal = Number(b.used_in_autocasts)
          console.log(`🔢 Sorting used_in_autocasts: "${a.name}" (${a.used_in_autocasts} → ${aVal}) vs "${b.name}" (${b.used_in_autocasts} → ${bVal})`)
          if(sort.sort_direction === 'asc') {
            const result = aVal - bVal
            return result
          } else {
            const result = bVal - aVal
            return result
          }
        } else if (sortField === 'active') {
          const aVal = Number(a.autocast_is_active)
          const bVal = Number(b.autocast_is_active)
          if(sort.sort_direction === 'asc') {
            const result = aVal - bVal
            return result
          } else {
            const result = bVal - aVal
            return result
          }
        } else if (sortField === 'channel') {
          const aVal = a.channel || ''
          const bVal = b.channel || ''
          if(sort.sort_direction === 'asc') {
            return aVal.localeCompare(bVal)
          } else {
            return bVal.localeCompare(aVal)
          }
        } else {
          // Дефолтная сортировка по number если поле не поддерживается
          const aNum = a.number ?? Infinity
          const bNum = b.number ?? Infinity
          
          if(sort.sort_direction === 'asc') {
            return aNum - bNum
          } else {
            return bNum - aNum
          }
        }
      })
      commit('setEmailsTemplatesList', new_sort)
    },
    deleteEmailTemplateById ({ commit, state, dispatch }, deleted_id) {
      let remaining_templates = state.items.filter(function(item) {
        if(item.id !== deleted_id) return true
      })
      commit('setEmailsTemplatesList', remaining_templates)
    },
    addNewTemplate ({ commit, state, dispatch }, template) {
      state.items.push(template)

      commit('setEmailsTemplatesList', state.items)
    },
  },
  getters: {
    getAllEmailsTemplates: (state) => {
      return state.items
    },
    getEmailsTemplateById: (state) => (id) => {
      if(state.items && state.items.length > 0) {
        let result = state.items.filter(function(item) {
          if(item.id === id) return true
        })
        return result[0]
      }
      else {
        return null
      }
    },
    getEmailTemplateById: (state) => (id) => {
      return state[id]
    },
    getStripoDefaultTemplates: (state) => {
      return state.stripo_default_templates
    }
  }
}

export default emailsTemplatesModule



// WEBPACK FOOTER //
// ./src/store/modules/emails_templates.js